











import { ciEnvelope } from '~/icons/source/solid/envelope'
import { mapDeps } from '~/plugins/dependency-container/utils'
import ScrollService from '~/services/scroll/ScrollService'
import { defineComponent } from '~/utils/nuxt3-migration'

export default defineComponent({
  computed: {
    icon() {
      return ciEnvelope
    },
    ...mapDeps({
      scrollService: ScrollService
    })
  },
  methods: {
    scrollToContactSection() {
      const contactElem = document.getElementById('contact')

      if (contactElem) {
        this.scrollService.scrollTo(contactElem, {
          duration: 500,
          easing: 'ease-out',
          offset: -50,
          onDone: () => {
            try {
              contactElem.classList.add('highlight')
              setTimeout(() => {
                contactElem.classList.remove('highlight')
              }, 3000)
            } catch (e) {
              this.$logger.captureError(e)
            }
          }
        })
      }
    }
  }
})
